import { ProductionOrders } from './models/business/production-orders';
import { GlobalObject } from './models/business/global-object';
import { ServiceContract } from './models/business/service-contract';
import { BillOfMaterials } from './models/business/billOfMaterials';
import { NotifyService } from './services/notify.service';
import { StockTransfer } from './models/business/stock-transfer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from 'src/app/layout/layout.service';
import { BrowserModule } from '@angular/platform-browser';
//import * as Sentry from '@sentry/angular';
//import { Integrations } from '@sentry/tracing';

import {
  APP_INITIALIZER,
  ErrorHandler,
  LOCALE_ID,
  NgModule,
  enableProdMode,
} from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';
import { AppInitService } from './services/app-init.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { FormsModule } from '@angular/forms';
import { ErrorDialogService } from './error-dialog/errordialog.service';

import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgZorroModule } from './ng-zorro.module';
import { Documents } from './models/business/documents';
import { Payments } from './models/business/payments';
import { SalesOpportunity } from './models/business/sales-opportunity';
import { NzModalService } from 'ng-zorro-antd/modal';
import { HttpConfigInterceptor } from './intreceptor/httpconfig.interceptor';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { momentAdapterFactory } from './apps/crm/crm.module';
import { Wms } from './models/business/wms';
import { businessPartners } from './models/business/businessPartners';
import { BillOfMaterialService } from './services/BillOfMaterial.service';
import { ServiceCall } from './models/business/ServiceCall';
import { GlobalWebsiteService } from './apps/global-site/global-website.service';
import {
  firebaseConfig,
  initializeFirebaseApp,
} from './apps/timesheet/time-logic';
import { AngularFireModule, FIREBASE_OPTIONS } from '@angular/fire';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import {
  MsalBroadcastService,
  MsalModule,
  MsalService,
  MSAL_INSTANCE,
} from '@azure/msal-angular';
import { MSALInstanceFactory } from './MsalInstanceFactory';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { dbConfig } from './apps/storage/indexedDB/indexedDB';
import { NgxIndexedDBModule } from 'ngx-indexed-db';
import { DeliverScheduleUtil } from './models/business/deliverScheduleUtil';
import { BatchingInterceptor } from './intreceptor/batching.interceptor';
// enableProdMode();
export function initializeBWEB(appInitService: AppInitService) {
  return (): Promise<any> => {
    return appInitService.init(false);
  };
}

// Sentry.init({
//   dsn: 'https://4bb94f2b81b0d3a0d651e913fe38db68@o4509887218909184.ingest.de.sentry.io/4509887224545360',
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.routingInstrumentation,
//       // v7 older name:
//       tracingOrigins: [/^http?:\/\//, /^\//],

//       // for newer v7 builds, the name changed (same idea):
//       // tracePropagationTargets: [/^https?:\/\//, /^\//],

//       // keep control with a filter:
//       shouldCreateSpanForRequest: (url) => true, // (you can refine this below)
//     }),
//   ],
//   tracesSampleRate: 0.5, // lower in prod
// });

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    LayoutModule,
    AppRoutingModule,
    NoopAnimationsModule,
    NgZorroModule,
    IconsProviderModule,
    FormsModule,
    HttpClientModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireMessagingModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: momentAdapterFactory,
    }),
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: 'b5f22847-7fd9-4536-a3ef-679c423ae6a3',
          redirectUri: 'http://localhost:4200/',
          authority:
            'https://login.microsoftonline.com/1a60a93c-213a-4da4-b4ac-a6311c0b1a14/',
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: false,
        },
      }),
      {
        interactionType: InteractionType.Redirect, // MSAL Guard Configuration
      },
      {
        interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration,
        protectedResourceMap: null,
      }
    ),
    NgxIndexedDBModule.forRoot(dbConfig),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeBWEB,
      deps: [AppInitService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BatchingInterceptor,
      multi: true,
    },
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({ showDialog: false }),
    // },
    {
      provide: ErrorDialogService,
    },
    { provide: FIREBASE_OPTIONS, useValue: firebaseConfig },
    { provide: LOCALE_ID, useValue: 'en-US' },
    LayoutService,
    GlobalWebsiteService,
    // {
    //   provide: MSAL_INSTANCE,
    //   useFactory: MSALInstanceFactory,
    //   multi: true,
    // },
    MsalService,
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  documents: Documents;
  deliverScheduleUtil: DeliverScheduleUtil;
  productionOrders: ProductionOrders;
  globalObject: GlobalObject;
  payments: Payments;
  salesOpportunity: SalesOpportunity;
  stockTransfer: StockTransfer;
  wms: Wms;
  BPSection: businessPartners;
  billOfMaterials: BillOfMaterials;
  serviceContract: ServiceContract;
  serviceCall: ServiceCall;
  constructor(
    layoutService: LayoutService,
    messageService: NzMessageService,
    modalService: NzModalService,
    notifyService: NotifyService,
    billOfMaterialService: BillOfMaterialService,
    http: HttpClient
  ) {
    LayoutService.initQueue(http, layoutService);

    this.documents = new Documents(layoutService, messageService, modalService);
    this.deliverScheduleUtil = new DeliverScheduleUtil(layoutService);
    this.productionOrders = new ProductionOrders(
      layoutService,
      messageService,
      billOfMaterialService
    );
    this.globalObject = new GlobalObject();
    this.salesOpportunity = new SalesOpportunity(layoutService, messageService);
    this.serviceContract = new ServiceContract(layoutService, messageService);
    this.payments = new Payments(layoutService, messageService);
    this.stockTransfer = new StockTransfer(
      layoutService,
      messageService,
      modalService
    );
    this.wms = new Wms(
      layoutService,
      layoutService.notification,
      messageService
    );
    this.billOfMaterials = new BillOfMaterials(
      layoutService,
      messageService,
      billOfMaterialService
    );
    this.serviceCall = new ServiceCall(layoutService, messageService);
    this.BPSection = new businessPartners(layoutService, messageService);
  }
}
